import { useDisclosure } from '@mantine/hooks';
import type { ESQueryModel } from '@repo/api-codegen';
import type { ReactNode } from 'react';
import { useCallback, useMemo, useState } from 'react';
import { QueryDrawerContext } from './types';

export function QueryDrawerProvider({ children }: { children: ReactNode }) {
	const [query, setQuery] = useState<ESQueryModel | null>(null);
	const [opened, { open, close }] = useDisclosure(false);

	const handleOpen = useCallback(
		(query: ESQueryModel | null) => {
			setQuery(query);
			if (query) {
				open();
			}
		},
		[setQuery, open]
	);

	const contextValue = useMemo(
		() => ({
			query,
			openQuery: handleOpen,
			opened,
			close,
		}),
		[query, handleOpen, opened, close]
	);

	return (
		<QueryDrawerContext.Provider value={contextValue}>
			{children}
		</QueryDrawerContext.Provider>
	);
}
